import React,{useContext} from 'react';
import {NavLink} from 'react-router-dom';
import { AuthContext } from '../../context/auth-context';
import Button from '../FormElements/Button';
import './NavLinks.css';
export default function NavLinks()
{
    const auth=useContext(AuthContext);
    
    return (<>
    <ul className='nav-links'>
        <li>
            <NavLink to="/" exact>ALL USERS</NavLink>
        </li>
        {auth.isLoggedIn && <li>
            <NavLink to={`/${auth.userId}/places`}>MY PLACES</NavLink>
        </li>}
        {auth.isLoggedIn && <li>
            <NavLink to="/place/new">ADD PLACE</NavLink>
        </li>}
        {!auth.isLoggedIn &&<li>
            <NavLink to="/auth">Authentication</NavLink>
        </li>}
        {auth.isLoggedIn && <li>
            <Button onClick={auth.logout}>LOGOUT</Button>
        </li>}
    </ul>
    </>);
}